import {
  Button,
  DatePicker,
  Divider,
  NumberInput,
  Select,
  SelectItem,
  TextInput,
  Textarea,
} from "@tremor/react";
import React, { useEffect, useState } from "react";
import { baseURL } from "./backend/baseData";
import axios from "axios";
import { toast } from "react-toastify";
import { redirect } from "react-router-dom";

const CreateNormalTask = () => {
  const [formData, setFormData] = useState({
    task_name: "",
    challenge: "",
    task_type: "stepCounter",
    player_level: 1,
    description: "",
    image: null,
    page_id: 2,
    title:"",
    duration:null,
    direction:null,
    steps:0
  });
  const [challenges, setChallenges] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getInactiveChallengesNormal.php?id=2`
        );
        if (response.status === 200 && Array.isArray(response.data)) {
          console.log(response.data);
          setChallenges(response.data);
        } else {
          console.error(
            "Invalid response format or failed to fetch challenges"
          );
          setChallenges([]);
        }
      } catch (error) {
        console.error("Error while fetching challenges:", error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDistricts();
  }, []);
  const handleChange = (event) => {
    const { name, value, files } = event.target;

    // Check if the input name is "image"
    if (name === "image") {
      // Update formData.image directly with the uploaded file
      setFormData((prevData) => ({
        ...prevData,
        image: URL.createObjectURL(files[0]), // Assuming single file upload
      }));

      // Update the existing image state (e.g., imageURL) to display a preview of the uploaded image
    } else {
      // For other inputs
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleSelectChange = (task_name, values) => {
    setFormData((prevData) => ({
      ...prevData,
      [task_name]: values,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validate form data

    const validationErrors = {};
    if (!formData.task_name.trim()) {
      validationErrors.task_name = "Task Name is required";
    }

    if (!formData.challenge.trim()) {
      validationErrors.challenge = "Challenge is required";
    }
    // Add validation for other fields

   
    if (!formData.player_level) {
      validationErrors.player_level = "Player Level is required";
    } else if (isNaN(formData.player_level)) {
      validationErrors.player_level = "Player Level must be a number";
    }
    if (!formData.description.trim()) {
      validationErrors.description = "Description is required";
    }
    if (!formData.image) {
      validationErrors.image = "Image is required";
    }

    // Add validation for other fields

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // If validation passes, submit the form data
    const formDataToSend = new FormData();

    // Append all form fields to FormData
    Object.entries(formData).forEach(([key, value]) => {
      // Append everything except image to FormData
      if (key !== "image") {
        formDataToSend.append(key, value);
      }
    });

    try {
      // Fetch the image data
      const response = await fetch(formData.image);
      const blob = await response.blob();

      // Append image blob to FormData
      formDataToSend.append("image", blob, "image.png");

      // Submit the form data
      const submitResponse = await axios.post(
        `${baseURL}/createNormalTasks.php`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Handle successful submission
      console.log("Form submitted successfully:", submitResponse.data);
      const notify = () => {
        toast.success("Task Created Successfully!");
      };
      if (response.status === 200) {
        notify();
        return redirect("/challenges");
      }
    } catch (error) {
      // Handle submission error
      console.error("Error submitting form:", error.message);
    }
  };

  return (
    <div className="w-full  bg-[#f1f5f9]">
      <div className="w-full shadow-slate-300 ">
        {/* <div className="flex justify-end w-full p-3">
            <Link className="w-fit p-3 bg-red-600 rounded-md flex gap-3 items-center" to={"/create-challenge"}>
              <RiAddCircleLine size={20} color="white" />
              <p className="text-white">Create</p>
            </Link>
          </div> */}
      </div>
      <Divider />
      <div className="w-full p-3 ">
        <div className="w-full  mt-5 gap-2 p-3 shadow-md bg-white border border-slate-50 rounded-md">
          <h4 className="font-bold text-xl mt-2">Create Visit Task</h4>
          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-12 mt-2 gap-3"
          >
            <div className="col-span-12 md:col-span-6 space-y-2">
              <h6>Task Name</h6>
              <TextInput
                className="w-full min-h-10"
                name="task_name"
                value={formData.task_name}
                onChange={handleChange}
              />
              {errors.task_name && (
                <p className="text-red-500">{errors.task_name}</p>
              )}{" "}
            </div>

            <div className="col-span-12 md:col-span-6 space-y-2">
              <h6>Challenge</h6>
              <Select
                name="challenge"
                value={formData.challenge}
                onValueChange={(value) =>
                  handleSelectChange("challenge", value)
                }
                className="min-h-10"
              >
                {challenges.length > 0 &&
                  challenges.map((item, index) => (
                    <SelectItem value={item.challenge_id} key={index}>
                      {item.title}
                    </SelectItem>
                  ))}
              </Select>
              {errors.challenge && (
                <p className="text-red-500">{errors.challenge}</p>
              )}{" "}
            </div>
            <div className="col-span-12 md:col-span-6 space-y-2">
              <h6>Task Type</h6>
              <Select
                name="task_type"
                value={formData.task_type}
                defaultValue="stepCounter"
                onValueChange={(value) =>
                  handleSelectChange("task_type", value)
                }
                className="min-h-10"
              >
                <SelectItem value={"stepCounter"}>Pedometer</SelectItem>
                <SelectItem value={"videoCapture"}>Video Capture</SelectItem>
                <SelectItem value={"mediaCapture"}>Image Capture</SelectItem>
              </Select>
              {errors.challenge && (
                <p className="text-red-500">{errors.task_type}</p>
              )}{" "}
            </div>

            <div className="col-span-12 md:col-span-6 space-y-2">
              <h6>Player Level</h6>
              <NumberInput
                value={formData.player_level}
                name="player_level"
                onChange={handleChange}
                defaultValue={1}
                disabled
                className="w-full min-h-10"
              />
              {errors.player_level && (
                <p className="text-red-500">{errors.player_level}</p>
              )}
            </div>
            {formData.task_type == "videoCapture" ||
            formData.task_type == "mediaCapture" ? (
              <>
                <div className="col-span-12 md:col-span-6 space-y-2">
                  <h6>Title</h6>
                  <TextInput
                className="w-full min-h-10"
                name="title"
                value={formData.title}
                onChange={handleChange}
              />
                </div>
                {formData.task_type == "videoCapture" && (
                  <div className="col-span-12 md:col-span-6 space-y-2">
                    <h6>Duration (optional)</h6>
                    <NumberInput
                      value={formData.duration}
                      name="duration"
                      onChange={handleChange}
                      className="w-full min-h-10"
                    />
                  </div>
                )}
              </>
            ) : (
                <>
                <div className="col-span-12 md:col-span-6 space-y-2">
                  <h6>Steps</h6>
                  <NumberInput
                    value={formData.steps}
                    name="steps"
                    onChange={handleChange}
                    className="w-full min-h-10"
                  />
                </div>
                <div className="col-span-12 md:col-span-6 space-y-2">
                  <h6>Direction (optional)</h6>
                  <Select
                name="direction"
                value={formData.direction}
                onValueChange={(value) =>
                  handleSelectChange("direction", value)
                }
                className="min-h-10"
              >
                <SelectItem value={"N"}>North</SelectItem>
                <SelectItem value={"NE"}>Northeast</SelectItem>
                <SelectItem value={"E"}>East</SelectItem>
                <SelectItem value={"SE"}>Southeast</SelectItem>
                <SelectItem value={"S"}>South</SelectItem>
                <SelectItem value={"SW"}>Southwest</SelectItem>
                <SelectItem value={"W"}>West</SelectItem>
                <SelectItem value={"NW"}>Northwest</SelectItem>
              </Select>
                </div>
              </>
            )}
            <div className="col-span-12 space-y-2">
              <h6>Description</h6>
              <Textarea
                value={formData.description}
                name="description"
                onChange={handleChange}
                rows={5}
                placeholder="Type here..."
                className="w-full min-h-10"
              />
              {errors.description && (
                <p className="text-red-500">{errors.description}</p>
              )}
            </div>
            <div className="col-span-12 space-y-2">
              <h6>Image</h6>
              <div className="mb-3 w-96">
                <input
                  // value={formData.image}
                  name="image"
                  onChange={handleChange}
                  className="relative m-0 block w-full min-w-0 flex-auto rounded border border-solid border-neutral-300 bg-clip-padding px-3 py-[0.32rem] text-base font-normal text-neutral-700 transition duration-300 ease-in-out file:-mx-3 file:-my-[0.32rem] file:overflow-hidden file:rounded-none file:border-0 file:border-solid file:border-inherit file:bg-neutral-100 file:px-3 file:py-[0.32rem] file:text-neutral-700 file:transition file:duration-150 file:ease-in-out file:[border-inline-end-width:1px] file:[margin-inline-end:0.75rem] hover:file:bg-neutral-200 focus:border-primary focus:text-neutral-700 focus:shadow-te-primary focus:outline-none dark:border-neutral-600 dark:text-neutral-200 dark:file:bg-neutral-700 dark:file:text-neutral-100 dark:focus:border-primary"
                  type="file"
                  accept="image/png, image/jpeg"
                  id="formFile"
                />
                {errors.image && <p className="text-red-500">{errors.image}</p>}
              </div>
              <div className="col-span-12 space-y-2">
                <Button variant="primary">Submit</Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateNormalTask;
